module.exports = __webpack_public_path__ + "img/interactive.10753a1a.png";